import React, { useState, useEffect } from "react";
import { auth, firestore } from "./firebase";
import { signOut } from "firebase/auth";
import { doc, getDoc, collection, query, where, getDocs } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";
import "./Wallet.css";
import BellIcon from "./assets/bellIcon.svg";

import Green from "./assets/downGreen.svg";
import Redd from "./assets/UpRed.svg";
import Plusam from "./assets/addwallet.svg";
import Wrong from "./assets/Subtractgg.svg";
import BottomBar from "./BottomBar/BottomBar";


const Wallet = () => {
  const [userData, setUserData] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          console.log("Authenticated user UID:", user.uid);
          const userDocRef = doc(firestore, "users", user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            console.log("User data found:", userDoc.data());
            const data = userDoc.data();
            setUserData(data);
            setWalletBalance(data.balance || 0);

            // Fetch transactions
            fetchTransactions(user.uid);
          } else {
            console.log("No user data found for UID:", user.uid);
          }
        } else {
          console.log("No authenticated user found");
        }
      } catch (error) {
        console.error("Error fetching user data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const fetchTransactions = async (userId) => {
    try {
      const transactionsQuery = query(
        collection(firestore, "transactions"),
        where("userId", "==", userId)
      );
      const transactionsSnapshot = await getDocs(transactionsQuery);
      const transactionsList = transactionsSnapshot.docs.map((doc) => ({
        ...doc.data(),
        date: doc.data().date.toDate(), // Convert Firestore timestamp to JS Date
      }));
      setTransactions(transactionsList);
    } catch (error) {
      console.error("Error fetching transactions: ", error);
    }
  };

  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/");
  };

  const formatTransactionsData = () => {
    const groupedData = transactions.reduce((acc, transaction) => {
      const date = transaction.date.toLocaleDateString();
      if (!acc[date]) {
        acc[date] = { date, amount: 0 };
      }
      acc[date].amount += transaction.amount;
      return acc;
    }, {});
    const formattedData = Object.values(groupedData);
    console.log("Formatted Transactions Data for Histogram:", formattedData); // Debugging log
    return formattedData;
  };

  const renderTransactionIcon = (type) => {
    if (type === 'income') {
      return <img src={BellIcon} alt="" />;
    } else if (type === 'expense') {
      return <img src={BellIcon} alt="" />;
    }
    return null;
  };

  if (loading) {
    return <div className="loader"></div>;
  }

  if (!userData) {
    return (
      <div>
       <div className="no-data">
        <img src={Wrong} style={{width: 60}} alt="wrog" />
       <div className="wrongTecxt">
       <h4 style={{fontSize: 20}}>
       Unable to Reach Your Account
       </h4>
       <p>Please use the login button below to login into your account</p>
       </div>
        <button className="nodatainput" onClick={handleSignOut}>
          Login Here
        </button>
        <div style={{ color: '#00000050', width: '90%', textAlign: 'center'}}>
            ------------------ Or -------------------
            </div>
        <button className="nodatainputwhite" onClick={() => navigate('/signup')}>
          Create Your Account
        </button>
      </div>

      <div className="no-data-bottom">
        {/* <img src={Wrong} style={{width: 60}} alt="wrog" /> */}
       <div className="wrongTecxt">
       <h4 style={{fontSize: 20}}>
      At UBS Bank your Security is our priority
       </h4>
       <p>If we notice any illegal login or activities on your account we will log it out immediately</p>
       </div>
        
      </div>
     </div>
    )
  }

  const { income, expenses } = transactions.reduce((totals, transaction) => {
    if (transaction.type === 'income') {
      totals.income += transaction.amount;
    } else if (transaction.type === 'expense') {
      totals.expenses += transaction.amount;
    }
    return totals;
  }, { income: 0, expenses: 0 });

  return (
    <div className="dashboard">
      <div className="profile">
        <div className="flexer">
          <img 
            src={userData.photoURL || "./assets/notification-icon.png"}
            alt="Profile"
            className="profile-imagee"
          />
     
        </div>
            <h2 className="namee"><a className="namee" href="/profile">Wallet</a></h2>
        <img src={BellIcon} alt="Bell Icon" style={{width: 28, height: 28}} />
      </div>


      <div className="earningblockf">
      <div className="earningDiff">
          <img src={Plusam} alt="plus" />
        
        </div>


        <div className="earningf">
          <div
            style={{
              width: '100%',
              height: '80%',
              
              backgroundColor: "#FBE5A3",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              flexDirection: 'row'
            }}
          >
              <div className="wallettt">
            <p className="wallete">Total Wallet Balance</p>
            <div className="moneyy">
              <h3 className="WalletBalance" style={{color: '#2a2a2a'}} >$</h3>
              <h3 className="WalletBalanceBig" style={{color: '#2a2a2a'}} >
                {parseFloat(walletBalance).toLocaleString()}
              </h3>
            </div>
            <p style={{marginTop: 25}}>2356 ....  .... 3653</p>
          </div>

          
          </div>
          <div className="earnnf">
            <div style={{ fontSize: 15, fontWeight: "500", color: "#ffffff90" }}>
              Name
            </div>
            <div style={{ fontSize: 17, fontWeight: "bold", color: "#ffffff" }}>
              {userData.username}
            </div>
          </div>
        </div>


        <div className="earningf">
          <div
            style={{
              width: '100%',
              height: '80%',
              
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              flexDirection: 'row'
            }}
          >
              <div className="wallettt">
            <p className="wallete">Total Wallet Balance</p>
            <div className="moneyy">
              <h3 className="WalletBalance" style={{color: '#2a2a2a'}}>$</h3>
              <h3 className="WalletBalanceBig" style={{color: '#2a2a2a'}}>
                {parseFloat(walletBalance).toLocaleString()}
              </h3>
            </div>
            <p style={{marginTop: 25}}>2356 .... .... 3653</p>
          </div>

          
          </div>
          <div className="earnnf">
            <div style={{ fontSize: 15, fontWeight: "500", color: "#ffffff90" }}>
              Name
            </div>
            <div style={{ fontSize: 17, fontWeight: "bold", color: "#ffffff" }}>
              {userData.username}
            </div>
          </div>
        </div>


        
      </div>



      <div className="underwallet">
        <div className="underWalletIncome">
          <img src={Green} alt="Green Icon" />
          <div className="underText">
            <p>Income</p>
            <p className="diffp">${parseFloat(income).toLocaleString()}</p>
          </div>
        </div>
        <div className="underWalletIncomee">
          <img src={Redd} alt="Red Icon" />
          <div className="underText">
            <p>Expenses</p>
            <p className="diffp">${parseFloat(expenses).toLocaleString()}</p>
          </div>
        </div>
      </div>


      <div className="moreSection">
        <p className="lower">Recent Transactions</p>
        <Link to="/CreateTransaction" className="blue">See all</Link>
      </div>

      <div className="transactions-container">
        {transactions.length > 0 ? (
          <ul className="transaction-list">
            {transactions.map((transaction, index) => (
              <li key={index} className="transaction-item">
                <div className="transaction-icon">
                  {renderTransactionIcon(transaction.type)}
                </div>
                <div className="transaction-details">
                  <div className="transaction-title">{transaction.title}</div>
                  <div>
                    <div className="transaction-description">{transaction.description}</div>
                    <span>{transaction.date.toLocaleDateString()}</span>
                  </div>
                </div>
                <div className="transaction-titlee">${parseFloat(transaction.amount).toLocaleString()}</div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No recent transactions.</p>
        )}
      </div>

    

      <div className="moreSection">
        <p className="lower">Recent Transactions</p>
        <Link to="/CreateTransaction" className="blue">See all</Link>
      </div>

      <div className="transactions-container">
        {transactions.length > 0 ? (
          <ul className="transaction-list">
            {transactions.map((transaction, index) => (
              <li key={index} className="transaction-item">
                <div className="transaction-icon">
                  {renderTransactionIcon(transaction.type)}
                </div>
                <div className="transaction-details">
                  <div className="transaction-title">{transaction.title}</div>
                  <div>
                    <div className="transaction-description">{transaction.description}</div>
                    <span>{transaction.date.toLocaleDateString()}</span>
                  </div>
                </div>
                <div className="transaction-titlee">${parseFloat(transaction.amount).toLocaleString()}</div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No recent transactions.</p>
        )}
      </div>
      <BottomBar />

      <button className="input" onClick={handleSignOut}>
        Sign Out
      </button>
    </div>
  );
};

export default Wallet;
